module.exports = __webpack_public_path__ + "img/bg_function06_4_d.0b7a1104.svg";